<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" width="600px">
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Переменная</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="saveValue" :disabled="!this.valid || mainValid">
                            <v-icon>save</v-icon>
                            {{variableModel.id === null ? ' Создать' : ' Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list subheader class="content">
                    <v-container>
                        <v-form
                                ref="form"
                                v-model="valid"
                        >
                            <v-row class="d-flex">
                                <v-col cols="12" md12 class="py-0">
                                    <v-text-field
                                            v-model="variableModel.title"
                                            :counter="35"
                                            label="Название переменной"
                                            required
                                            class="ma-2 pa-2"
                                            :rules="[rules.required, rules.maxLengthTitle]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-text-field
                                            v-model="variableModel.alias"
                                            :counter="35"
                                            label="Псевдоним переменной (Для модулей)"
                                            class="ma-2 pa-2"
                                            :rules="[rules.maxLengthTitle]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-textarea
                                            auto-grow
                                            rows="1"
                                            name="input-7-1"
                                            :counter="150"
                                            v-model="variableModel.description"
                                            label="Описание"
                                            required
                                            class="ma-2 pa-2 my-0 py-0"
                                            :rules="[rules.maxLengthText]"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="7" md12 class="py-0 px-7">
                                    <v-btn-toggle v-model="variableModel.type" mandatory>
                                        <v-btn text value="text" small>
                                            Строка
                                        </v-btn>
                                        <v-btn text value="number" small @click="variableModel.default_value = null">
                                            Число
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-col>
                                <v-col cols="7" md12 class="py-0 px-7">
                                    <v-btn-toggle v-model="variableModel.form" mandatory>
                                        <v-btn text value="normal" small>
                                            Стандартная
                                        </v-btn>
                                        <v-btn text value="global" small>
                                            Глобальная
                                        </v-btn>
                                        <v-btn text value="dynamic" small>
                                            Динамическая
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-col>
                                <v-col cols="12" md12 class="py-0" v-show="variableModel.form == 'global'">
                                    <v-text-field
                                            v-model="variableModel.value"
                                            label="Значение"
                                            hide-details
                                            required
                                            class="ma-2 pa-2"
                                            :type="variableModel.type === 'text' ? 'text' : 'number'"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-text-field
                                            v-model="variableModel.default_value"
                                            label="Значение по умолчанию"
                                            hide-details
                                            required
                                            class="ma-2 pa-2"
                                            :type="variableModel.type === 'text' ? 'text' : 'number'"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" md12 class="py-0">
                                    <v-text-field
                                            v-model="variableModel.min"
                                            label="Минимальное значение"
                                            hide-details
                                            required
                                            class="ma-2 pa-2"
                                            type="number"
                                            v-if="variableModel.type === 'number'"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" md12 class="py-0">
                                    <v-text-field
                                            v-model="variableModel.max"
                                            label="Максимальное значение"
                                            hide-details
                                            required
                                            class="ma-2 pa-2"
                                            type="number"
                                            v-if="variableModel.type === 'number'"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" md12 class="py-0">
                                    <v-text-field
                                            v-model="variableModel.change_time"
                                            label="Изменять значение каждые"
                                            hide-details
                                            required
                                            class="ma-2 pa-2"
                                            type="number"
                                            v-if="variableModel.type === 'number' && variableModel.form === 'dynamic'"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" md12 class="py-0 px-7" v-if="variableModel.type === 'number' && variableModel.form === 'dynamic'">
                                    <v-btn-toggle v-model="variableModel.change_time_unit" mandatory>
                                        <v-btn text :value="1" small>
                                            Минут
                                        </v-btn>
                                        <v-btn text :value="60" small>
                                            Часов
                                        </v-btn>
                                        <v-btn text :value="3600" small>
                                            Дней
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-text-field
                                            v-model="variableModel.value_after_change"
                                            label="Изменять значение на"
                                            hide-details
                                            required
                                            class="ma-2 pa-2"
                                            v-if="variableModel.type === 'number' && variableModel.form === 'dynamic'"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import axios from 'axios'
// import constConf from '../../../constconf'
import { mapGetters } from 'vuex'

export default {
    name: 'MailingForm',
    props: ['variablesListId', 'editVariableId', 'dialog'],

    components: {
    },
    data() {
        return {
            show: false,
            isActive: false,
            variableModel: { id: null },
            selectedMailingGroups: { excepts: [], group_ids: [] },
            datePicker: '',
            theDate: new Date(),
            visKeyboardForm: false,
            keyboardModelDef: {
                id: null,
                title: 'Кнопка',
                bot_id: null,
                one_time: 1,
                hotkey: 0,
                visible: 1,
                struct: '{}'
            },
            keyboardModel: {
                id: null
            },
            messages: [],
            attachments: [],
            visAttachmentForm: false,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            jumpInfoDialog: false,
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 35) || 'Максимальная длина названия 28 символов.',
                maxLengthText: value => (value === null || value.length <= 700) || 'Максимальная длина сообщения 500 символов.',
                maxLengthButton: value => (value.length <= 20) || 'Максимальная длина названия 20 символов.',
                urlValid: value => (value !== null ? !!value.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9А-яЁё]+([\-\.]{1}[a-z0-9А-яЁё]+)*\.[a-zА-яЁё]{2,10}(:[0-9]{1,5})?(\/.*)?$/g) : false) || 'Ссылка имеет неверный формат. Пример верного формата https://app.chatway.ru/'
            },
            valid: false
        }
    },
    methods: {
        saveValue() {
            this.$store.dispatch('scenarios/variableCreate', this.variableModel).then(response => {
                if (response.type === 'CreateResult' || response.type === 'UpdateResult') {
                    this.variableModel.id = response.response.data.id
                    if (response.type === 'CreateResult') {
                        this.$emit('addVariablesToVariablesList', { variable: this.variableModel, variablesListId: this.variablesListId })
                    } else {
                        this.$emit('updateVariable', { variableModel: this.variableModel, variablesListId: this.variablesListId })
                    }
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Сохранение/создание прошло успешно!'
                } else {
                    this.paramsSnackbar.color = 'error'
                    this.paramsSnackbar.text = 'Ошибка при сохранении/создании перехода'
                }
                this.snackbar = true
            })
        },
        loadModel(variableId = null) {
            if (variableId === null) {
                this.variableModel = Object.assign({}, this.variableDefault)
            } else {
                this.variableModel = Object.assign({}, this.getVariableById(variableId))
            }
        },
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        },
        changeDate(date) {
            this.isActive = false
            date = new Date(date)
            date.setHours(this.theDate.getHours())
            date.setMinutes(this.theDate.getMinutes())
            this.theDate = date
        },
        changeTime(time) {
            this.isActive = false
            let date = new Date(this.theDate)
            date.setHours(time.split(':')[0])
            date.setMinutes(time.split(':')[1])
            this.theDate = date
        },
        selectKeyboard(keyboardId) {
            this.variableModel.keyboard_id = keyboardId === 0 ? null : keyboardId
            this.saveValue()
        },
        removeKeyboard(index) {
            if (this.variableModel.keyboard_id === this.keyboards[index].id) {
                this.variableModel.keyboard_id = null
                this.saveValue()
            }
            this.keyboards.splice(index, 1)
        },
        updateGroups(data) {
            this.selectedMailingGroups[data.field] = data.selectedMailingGroups
            this.variableModel[data.field] = data.group_ids
            this.otherValid = !this.valid && this.variableModel.type_list === 1 ? (this.variableModel.group_ids.length === 0) : false
        },
        updateAttachment(data) {
            this.attachments = data.selectedItems
            let attachments = data.selectedItems
            let ids = []
            for (let i = 0; i < attachments.length; i++) {
                ids.push(attachments[i].attachmentId)
            }
            if (data.saveMessage) {
                this.variableModel.attachment = ids.join(',')
                this.saveValue() // сохранить сообщение
            }
        },
        sendTestMessage() {
            this.$store.dispatch('mailings/sendTestMessage', this.variableModel)
        }
    },
    watch: {
        dialog() {
            if (this.dialog === true) {
                this.loadModel(this.editVariableId)
                this.otherValid = !this.valid && this.variableModel.type_list === 1 ? (this.variableModel.group_ids.length === 0) : false
                this.show = true
            } else {
                this.show = false
            }
        },
        show() {
            if (this.show === false) {
                this.variableModel = Object.assign({}, this.variableDefault)
                this.$refs.form.resetValidation()
                this.theDate = new Date()
                this.$emit('close')
            }
        }
    },
    computed: {
        formattedDate() {
            return this.zero(this.theDate.getDate()) + '.' + this.zero((this.theDate.getMonth() + 1)) + '.' + this.theDate.getFullYear()
        },
        formattedDatePicker() {
            return this.theDate.getFullYear() + '-' + this.zero((this.theDate.getMonth() + 1)) + '-' + this.zero(this.theDate.getDate())
        },
        formattedTime() {
            return this.zero(this.theDate.getHours()) + ':' + this.zero((this.theDate.getMinutes()))
        },
        ...mapGetters({
            variableDefault: 'scenarios/variableDefault',
            getVariableById: 'scenarios/getVariableById',
            mailingGroups: 'mailingGroups/mailingGroups',
            keyboards: 'keyboards/keyboards'
        }),
        mainValid() {
            return (this.variableModel.type_list === 1 ? (this.variableModel.group_ids.length === 0) : false)
        }
    },
    created() {
        this.$store.dispatch('mailings/changeBotIdModelDefault', this.$route.params['pathMatch'])
        this.keyboardModelDef.bot_id = this.$route.params['pathMatch']
        this.variableModel = Object.assign({}, this.variableModelDef)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
</style>
